import { useEffect, useState } from "react";
import { apiClient } from "@/App";
import { toast } from "sonner";
import { errorText } from "@/lib/calendar";
import { deviceLabel, fmtDate, REASON_LABELS } from "./format";

export const LoginAttemptsPanel = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    apiClient.get("/owner/login-attempts").then((r) => setData(r.data)).catch((e) => toast.error(errorText(e, "Could not load sign-in attempts")));
  }, []);

  if (!data) return <p className="text-slate-500 py-12">Loading…</p>;

  return (
    <div data-testid="owner-login-attempts-panel">
      <p className="text-sm text-slate-600 mb-4 max-w-2xl">
        Failed and blocked sign-ins, newest first. <span className="font-semibold" data-testid="owner-login-attempts-total">{data.total}</span> recorded in total.
        Successful sign-ins are not listed here.
      </p>
      <div className="bg-white border border-slate-200 rounded-2xl overflow-x-auto">
        <table className="w-full text-sm min-w-[760px]">
          <thead className="bg-slate-50 text-xs uppercase tracking-wider text-slate-500">
            <tr>
              <th className="px-4 py-3 text-left">When</th><th className="px-4 py-3 text-left">Email tried</th>
              <th className="px-4 py-3 text-left">Why it failed</th><th className="px-4 py-3 text-left">IP address</th>
              <th className="px-4 py-3 text-left">Device</th>
            </tr>
          </thead>
          <tbody>
            {data.attempts.map((a) => (
              <tr key={a.id || a.created_at} className="border-t border-slate-100" data-testid="owner-login-attempt-row">
                <td className="px-4 py-3 text-slate-500 whitespace-nowrap">{fmtDate(a.created_at)}</td>
                <td className="px-4 py-3 text-slate-900 break-all">{a.email}</td>
                <td className="px-4 py-3">
                  <span className={`text-xs font-semibold px-2 py-1 rounded-full ${a.reason === "bad_password" ? "bg-amber-100 text-amber-800" : "bg-slate-100 text-slate-600"}`}>
                    {REASON_LABELS[a.reason] || a.reason}
                  </span>
                </td>
                <td className="px-4 py-3 font-mono text-xs text-slate-700">{a.ip || "—"}</td>
                <td className="px-4 py-3 text-slate-600">{deviceLabel(a.user_agent)}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {data.attempts.length === 0 && <p className="text-center text-slate-400 py-10" data-testid="owner-login-attempts-empty">No failed sign-ins recorded.</p>}
      </div>
    </div>
  );
};
